import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
//import { Button, ListGroup, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import Impaginazione_bootstrap from "./Ditta_x8_paginazione.jsx";
  
 
const Lista_ditte = (props) => {
//    const [somma, calcola_somma] = useState('');


//        {/* idroslab  */} pagina da eliminare


    return (
        <>
  
        
            <Impaginazione_bootstrap lista_ditte= {props.lista_ditte} 
                                     tutor={props.tutor}   
                                     account_dati={props.account_dati}
                                     SET_variab_aggiorna={props.SET_variab_aggiorna} 
                                     state_paginazione={props.state_paginazione} SET_state_paginazione={props.SET_state_paginazione}
                                     ricerca_ditta = {props.ricerca_ditta}
                                     />
          
        
    </>
    )
}
export default Lista_ditte;